function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.47425 1.16663H9.53175C11.5092 1.16663 12.8334 2.55496 12.8334 4.61996V9.38638C12.8334 11.445 11.5092 12.8333 9.53175 12.8333H4.47425C2.49675 12.8333 1.16675 11.445 1.16675 9.38638V4.61996C1.16675 2.55496 2.49675 1.16663 4.47425 1.16663ZM6.66758 8.74413L9.43841 5.9733C9.63675 5.77496 9.63675 5.45413 9.43841 5.24996C9.24008 5.05163 8.91341 5.05163 8.71508 5.24996L6.30591 7.65913L5.28508 6.6383C5.08675 6.43996 4.76008 6.43996 4.56175 6.6383C4.36341 6.83663 4.36341 7.15746 4.56175 7.36163L5.95008 8.74413C6.04925 8.8433 6.17758 8.88996 6.30591 8.88996C6.44008 8.88996 6.56841 8.8433 6.66758 8.74413Z",
  fill: "#EF753F"
});
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.c5bceb7b225edd4596cd67a0e0fa9fa0.svg";
export { ForwardRef as ReactComponent };